module.exports = __webpack_public_path__ + "img/kairan.5b08ed51.jpg";